import { DefaultTheme } from 'styled-components';

const THEME: DefaultTheme = {
	color: {
		beige: '#fed2b4',
		beigeLight: '#fff9f7',
		black: '#2d2d2d',
		blackLight: '#666',
		blue: '#7bdbdc',
		creamy: '#fffdfd',
		grey: '#e0e0e0',
		greyDarker: '#828282',
		greyLight: '#f2f2f2',
		prune: '#3f062b',
		pruneLight: '#5A2A49',
		pruneSuperLight: '#c6b6c0',
		red: '#ff0046',
		rgbBeige: '254, 210, 180',
		rgbBlue: '124,220,221',
		rgbPrune: '62,6,43',
		rgbRed: '255,0,70',
		rgbWhite: '255, 255, 255',
		transparent: 'transparent',
		white: '#fff',
	},
	fontSize: {
		/** 8px */
		XXXSMALL: '0.5rem',
		/** 10px */
		XXSMALL: '0.625rem',
		/** 12px */
		XSMALL: '0.75rem',
		/** 14px */
		SMALL: '0.875rem',
		/** 16px */
		DEFAULT: '1rem',
		/** 18px */
		LARGE: '1.125rem',
		/** 20px */
		XLARGE: '1.25rem',
		/** 24px */
		XXLARGE: '1.5rem',
		/** 32px */
		XXXLARGE: '2rem',
		/** 36px */
		HEADLINE: '2.25rem',
		/** 46px */
		XHEADLINE: '2.875rem',
		/** 64px */
		XXHEADLINE: '4rem',
	},
};

export default THEME;
